export default "__VITE_ASSET__LGP3R_LP__"